module.exports = __webpack_public_path__ + "media/images/lb/495-c6d84b52dacebae1771d17bc3191b66e.svg";